import React from "react";
import Layout from "@components/layout";
import SEO from "@components/seo";
import Controls from "@components/Controls/controls";
import UniplacesFullContainer from "@components/UniplacesFullContainer/uniplacesFullContainer";
import HeroSection from "@components/HeroSection/heroSection";
import TabsSection from "@components/TabsSection/tabsSection";
import TimelineFlexible from "./timelines/timelineFlexible";
import TimelineModerate from "./timelines/timelineModerate";
import TimelineNonRefundable from "./timelines/timelineNonRefundable";
import TimelineStrict from "./timelines/timelineStrict";
import { useIntl } from 'react-intl';

const CancellationPoliciesTemplate = ({
  data: {
    cancellation_policies_hero_heading: {
      0: { text: heroHeading },
    },
    cancellation_policies_hero_subheading: {
      0: { text: heroSubheading },
    },
    cancellation_policies_hero_image,
    flexible_title: {
      0: { text: flexibleTitle },
    },
    flexible_text,
    moderate_title: {
      0: { text: moderateTitle },
    },
    moderate_text,
    non_refundable_title: {
      0: { text: nonRefundableTitle },
    },
    non_refundable_text,
    strict_title: {
      0: { text: strictTitle },
    },
    strict_text,
  },
  pageContext: { locale, activeTab, pageSlug },
}) => {
  const tabs = {
    flexible: {
      title: flexibleTitle,
      text: flexible_text,
      components: [ TimelineFlexible ]
    },
    moderate: {
      title: moderateTitle,
      text: moderate_text,
      components: [ TimelineModerate ]
    },
    strict: {
      title: strictTitle,
      text: strict_text,
      components: [ TimelineStrict ]
    },
    'non-refundable': {
      title: nonRefundableTitle,
      text: non_refundable_text,
      components: [ TimelineNonRefundable ]
    },
  };

  return (
    <Layout locale={locale}>
      <CustomSEO image={cancellation_policies_hero_image} title={tabs[activeTab].title} locale={locale} />
      <HeroSection
        heroHeading={heroHeading}
        heroSubheading={heroSubheading}
        heroImage={cancellation_policies_hero_image}
        height={240}
        lazyload={false}
      />
      <UniplacesFullContainer>
          <TabsSection
            tabs={tabs}
            defaultTab={activeTab ? activeTab : Object.keys(tabs)[0]}
            locale={locale}
            pageSlug={pageSlug}
            hasTitle={false}
          />
          <Controls />
      </UniplacesFullContainer>
    </Layout>
  );
};

const CustomSEO = ({
  image,
  title,
  locale,
}) => {
  const intl = useIntl();
  const metaTitle = `${intl.formatMessage({id: 'seo.cancellation_policies.title'})} - ${title}`;
  const metaDescription = `${intl.formatMessage({id: 'seo.cancellation_policies.description'})}`;

  return (
    <SEO
      title={metaTitle}
      description={metaDescription}
      imageUrl={image.url}
      lang={locale}
    />
  );
};

export default CancellationPoliciesTemplate;
